<template>
  <v-stepper
    v-model="orderStepper"
    class="orderStepper"
  >
    <v-toolbar>
      <v-btn
        v-if="orderStepper<5"
        icon
        @click="backPrevious"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>{{ titles[orderStepper] }}</v-toolbar-title>
    </v-toolbar>
    <v-stepper-header>
      <v-stepper-step
        :complete="orderStepper > 1"
        step="1"
      >
        Select Student
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="(orderStepper > 2)"
        step="2"
      >
        Student Information
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step
        :complete="orderStepper > 3"
        step="3"
      >
        Course Information
      </v-stepper-step>

      <v-divider></v-divider>
      <v-stepper-step
        :complete="(orderStepper > 4)"
        step="4"
      >
        Order Review
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step
        :complete="(orderStepper > 5)"
        step="5"
      >
        Payment
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card
          class="mb-12 mt-1"
          color="grey lighten-1"
        >
          <user-list
            ref="selectStudentList"
            :enable-search="true"
            :user-list="studentList"
            :search-callback="handleUserSearch"
            @remove="handleRemoveStudent"
          ></user-list>
          <h3 class="justify-center row mt-5 mb-5">
            OR
          </h3>
          <CreateStudent
            :student-form-config="studentFormConfig"
            @scanned="selectStudent"
          ></CreateStudent>
        </v-card>

        <v-btn
          color="primary"
          @click="selectStudent"
        >
          Continue
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card
          class="mb-12 mt-1"
          color="grey lighten-1"
        >
          <v-form
            ref="studentForm"
            v-model="studentFormValid"
            lazy-validation
          >
            <v-row>
              <v-col
                cols="12"
                md="8"
              >
                <InputContainer
                  ref="studentInfo"
                  :configs="studentFormConfig"
                >
                </InputContainer>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <div class="text-h5">
                  Avatar:
                </div>

                <ImageCropper
                  v-model="avatarFile"
                >
                </ImageCropper>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-btn
          color="primary"
          @click="saveStudentInfo"
        >
          Continue
        </v-btn>

        <!-- <v-btn
          text
          @click="orderStepper = 2"
        >
          Back
        </v-btn> -->
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
          class="mb-12 mt-1"
          color="grey lighten-1"
        >
          <v-form
            ref="orderForm"
            v-model="orderFormValid"
            lazy-validation
          >
            <InputContainer
              ref="courseInfo"
              :configs="courseConfig"
              @input="handleCourseUpdate"
            >
            </InputContainer>
            <user-list
              v-if="coachList.length>0"
              ref="selectCoachList"
              :enable-search="true"
              :user-list="coachList"
              :rule="selectCoachRule"
              error-message="Please select atleast one coach."
              :limit="3"
            ></user-list>
            <InputContainer
              ref="orderInfo"
              :configs="orderFormConfig"
            >
            </InputContainer>
          </v-form>
        </v-card>

        <v-btn
          color="primary"
          @click="saveOrderInfo"
        >
          Continue
        </v-btn>

        <!-- <v-btn
          text
          @click="orderStepper = 1"
        >
          Back
        </v-btn> -->
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-card
          class="mb-12 mt-1"
          color="grey lighten-1"
        >
          <OrderReview
            ref="orderReview"
            @toggleBtn="handleToggleBtn"
            @print="handlePrint"
          ></OrderReview>
        </v-card>

        <!-- <v-btn
          :disabled="disableOrderReviewContinueBtn"
          color="primary"
          @click="(orderStepper = 5)"
        >
          Continue
        </v-btn> -->

        <!-- <v-btn
          text
          @click="orderStepper = 3"
        >
          Back
        </v-btn> -->
      </v-stepper-content>
      <v-stepper-content step="5">
        <v-card
          class="mb-12 mt-1"
          color="grey lighten-1"
        >
          <Payment ref="payment"></Payment>
        </v-card>

        <v-btn
          color="primary"
          @click="saveOrderPayment"
        >
          Confirm
        </v-btn>

        <!-- <v-btn
          text
          @click="orderStepper = 4"
        >
          Back
        </v-btn> -->
      </v-stepper-content>
    </v-stepper-items>
    <v-snackbar
      v-model="snackbar"
    >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-overlay
      :z-index="999"
      :value="isLoading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay> -->
  </v-stepper>
</template>
<script>
import moment from '@/utils/moment'
import InputContainer from '@/components/CRUD/InputContainer'
import UserList from '@/components/UserSelector/UserList'
import { createStudent } from '@/api/user'
import { createItem as createOrder, updateItem, createPayment, listCoach, uploadSignature } from '@/api/salesOrder'
import CreateStudent from './CreateOrder/CreateStudent'
import OrderReview from './CreateOrder/OrderReview'
import Payment from './CreateOrder/Payment'
import { formatDate, objectToFormData, base64ToFile, loading } from '@/utils/helper'
import ImageCropper from '@/components/Avatar/ImageCropper'

export default {
  components: {
    ImageCropper,
    CreateStudent,
    InputContainer,
    OrderReview,
    Payment,
    UserList,
  },
  data() {
    function isInt(value) {
      return !Number.isNaN(value)
         && parseInt(Number(value), 10) === value
         && !Number.isNaN(parseInt(value, 10))
    }

    return {
      courseID: -1,
      avatarFile: '',
      disableOrderReviewContinueBtn: true,
      studentFormValid: true,
      selectCoachRule: selectedList => {
        console.log('selectedList.length', selectedList.length)

        return selectedList.length > 0
      },
      orderFormValid: true,

      // isLoading: false,
      snackbar: false,
      message: '',
      studentList: [],
      allCoachList: [],
      coachList: [],
      fetchPromiseList: [],
      courseItems: [],
      programItems: [],
      programPriceItems: [],
      studentFormConfig: [
        {
          propName: 'firstName',
          label: 'First Name',
          type: {
            rules: [
              v => (typeof v === 'string' && v.length > 0) || 'First Name is required',
            ],
          },

        },
        {
          propName: 'lastName',
          label: 'Last Name',
          type: { rules: [
            v => (typeof v === 'string' && v.length > 0) || 'Last Name is required',
          ] },
        }, {
          propName: 'hkid',
          label: 'HK ID',
          type: { rules: [
            // e.g. a123456(7)
            v => (typeof v === 'string' && v.length === 10) || 'HKID is required',
          ] },
        }, {
          propName: 'birthday',
          label: 'Birthday',

          type: {
            name: 'datepicker',
            allowedDates: (val => {
              const result = moment(val).isBefore(moment())

              // console.log('allowedDates val result', val, result)

              return result
            }),
            rules: [
            // e.g. 1992-01-01
              v => (typeof v === 'string' && v.length === 10) || 'Birthday is required',
            ],
          },
        }, {
          propName: 'gender',
          label: 'Gender',
          required: true,
          type: {
            name: 'radioGroup',
            isHorizontal: true,
            groupItems: [
              { itemValue: 'M', itemName: 'M', label: 'Male' },
              { itemValue: 'F', itemName: 'F', label: 'Female' },
            ],
          },
        }, {
          propName: 'mobileNo',
          label: 'Telephone',
          required: true,
          type: { rules: [
            // e.g. 91123232
            v => (typeof v === 'string' && v.length === 8) || 'Telephone is required',
          ] },
        }, {
          propName: 'email',
          label: 'Email',
          required: true,
          type: { rules: [
            // e.g. 91123232
            v => (typeof v === 'string' && v.length > 0) || 'Email is required',
          ] },
        },
      ],
      courseConfig:
        [{
          propName: 'courseID',
          toplabel: 'Course',
          type: {
            name: 'radioGroup',
            isHorizontal: true,
            storeName: 'courseItems',
            rules: [
              v => !!isInt(v) || 'Course is required',
            ],
          },
        }],
      orderFormConfig: [
        {
          propName: 'orderTypeID',
          label: 'Order Type',
          defaultValue: 1,
          type: {
            name: 'select',
            storeName: 'orderTypeItems',
            itemText: 'description',
          },
        },
        {
          propName: 'programID',
          toplabel: 'Program',
          type: {
            name: 'radioGroup',
            isHorizontal: true,
            storeName: 'programItems',
            rules: [
              v => !!isInt(v) || 'Program is required',
            ],
          },
        },
        {
          propName: 'PricePerSession',
          toplabel: 'Price per session',
          type: {
            name: 'radioGroup',
            isHorizontal: true,
            storeName: 'programPriceItems',
            extraInput: {
              enabled: true,
              label: 'Custom Price',
              inputType: 'number',
            },
            rules: [
              v => !!isInt(v) || 'Price per sesssion is required',
            ],
          },
        },
        {
          propName: 'promotionID',
          label: 'Select Promotion',
          type: {
            name: 'autocomplete',
            storeName: 'promotionItems',
            itemText: 'fullName',
          },
        }],
      titles: {
        1: 'Search Existing Student',
        2: 'Student Information',
        3: 'Course Information',
        4: 'Order Review',
        5: 'Payment',
      },
      orderStepper: 1,

      isUpdating: false,
      name: 'Midnight Crew',
    }
  },
  computed: {
    studentData() {
      return this.$refs.studentInfo.editedItem
    },
    orderData() {
      return this.$refs.orderInfo.editedItem || {}
    },
  },
  watch: {
    isUpdating(val) {
      if (val) {
        setTimeout(() => {
          this.isUpdating = false
        }, 3000)
      }
    },
  },
  mounted() {
    this.$store.dispatch('course/list', {})
      .then(result => {
        console.log('course result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    this.$store.dispatch('program/list', {})
      .then(result => {
        console.log('course result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    this.$store.dispatch('programPrice/list', {})
      .then(result => {
        console.log('course result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    this.$store.dispatch('promotion/list', {})
      .then(result => {
        console.log('promotion result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    this.$store.dispatch('orderType/list', {})
      .then(result => {
        console.log('orderType result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    this.$store.dispatch('users/listStudent')
      .then(result => {
        console.log('listStudent result', result)
        this.studentList.push(...result)
      })
      .catch(err => {
        console.log('err', err)
      })

    // this.$store.dispatch('users/listCoach')
    //   .then(result => {
    //     console.log('listCoach result', result)
    //     this.coachList.push(...result)
    //   })
    //   .catch(err => {
    //     console.log('err', err)
    //   })
    //   listCoach({
    //   page: 0,
    //   limit: 0,
    // })

    this.orderData.effectiveDate = formatDate(moment().startOf('day').utc())

    // this.orderStepper = 4

    // // resize canvas for signature
    // this.$nextTick(() => {
    //   console.log('this.$refs.orderReview', this.$refs.orderReview)
    //   this.$refs.orderReview.resizeCanvas()
    // })

    this.$forceUpdate()

    loading(false)
  },
  methods: {
    async handlePrint(imageData) {
      loading(true)
      const formData = objectToFormData(this.$store.getters.orderInfo)
      const signatureFileObj = await base64ToFile(imageData, 'signature.png')
      if (!(signatureFileObj)) {
        alert('Please sign the signature.')
        loading(false)
      }
      formData.append('signature', signatureFileObj)
      uploadSignature(formData)
        .then(result => {
          console.log('uploadSignature result', result)
          console.log('this.$refs.orderReview', this.$refs.orderReview)
          this.$refs.orderReview.printOrder()
          this.orderStepper = 5
        })
        .catch(err => {
          console.log('err', err)
        }).finally(() => {
          loading(false)
        })
    },
    handleCourseUpdate(key, value) {
      this.courseID = value
      let selectedCoachIDs = []
      if (this.$refs.selectCoachList) {
        if (this.$refs.selectCoachList.selectedList.length > 0) {
          console.log('selected coach', this.$refs.selectCoachList.selectedList)
          selectedCoachIDs = this.$refs.selectCoachList.selectedList.map(record => record.id)
        }
      }
      this.coachList = this.allCoachList.filter(coach => {
        // console.log('coach.courses', coach.courses)
        if (coach.courses) {
          const courseList = coach.courses.filter(courseItem => courseItem.courseID === this.courseID)

          // console.log('courseList', courseList)
          if (courseList.length > 0 && !selectedCoachIDs.includes(coach.id)) {
            return true
          }
        }

        return false
      })

      // console.log('this.coachList', this.coachList)
    },
    handleUserSearch(record, newValue) {
      return record.fullName.toLowerCase().includes(newValue)
    },
    handleRemoveStudent() {
      console.log('handleRemoveStudent')
      this.$store.dispatch('order/resetNewMember').then(newMember => {
        // console.log('store newMember', newMember)
      })
    },
    handleToggleBtn(toggleBtn) {
      console.log('handleToggleBtn', toggleBtn)
      this.disableOrderReviewContinueBtn = toggleBtn
    },
    backPrevious() {
      if (this.orderStepper > 1) {
        this.orderStepper -= 1
      }
    },
    showMessage(message) {
      this.message = message
      this.snackbar = true
    },
    selectStudent() {
      console.log('selectStudent')
      if (this.$refs.selectStudentList.selectedList.length > 0) {
        const selectedStudent = this.$refs.selectStudentList.selectedList[0]
        console.log('selectedStudent', selectedStudent)
        this.$store.dispatch('order/saveNewMember', selectedStudent).then(newMember => {
          console.log('store newMember', newMember)
        })
      }
      console.log('this.$store.getters.newMember.init', this.$store.getters.newMember.init)
      if (this.$store.getters.newMember.init) {
        this.showMessage('Please select existing student or scan the HKID.')
      }

      // set user info to review page
      this.$set(this.$refs.studentInfo, 'editedItem', this.$store.getters.newMember)
      this.$nextTick(() => {
        if (this.$store.getters.newMember.id) {
          // set user info to review page
          this.$refs.orderInfo.updateValue('orderTypeID', 2)
        } else {
          this.$refs.orderInfo.updateValue('orderTypeID', 1)
        }
      })
      try {
        // avatarFile.value = computed(() => process.env.VUE_APP_BASE_API + e.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')
        this.avatarFile = process.env.VUE_APP_BASE_API + this.$store.getters.newMember.avatar
      } catch (err) {
        console.log('errerr', err)
        this.avatarFile = ''
      }
      this.orderStepper = 2
    },
    saveOrderInfo() {
      // console.log('this.$refs.orderForm.validate()')
      const orderFormResult = this.$refs.orderForm.validate()
      const selectCoachResult = this.$refs.selectCoachList.validate()
      console.log('selectCoachResult', selectCoachResult)
      if (orderFormResult && selectCoachResult) {
        const { editedItem } = this.$refs.orderInfo
        editedItem.selectedCoachList = []
        if (this.$refs.selectCoachList.selectedList.length > 0) {
          editedItem.selectedCoachList.push(...this.$refs.selectCoachList.selectedList)
        }
        let orderData = { ...this.$store.getters.orderInfo }
        orderData = Object.assign(orderData, editedItem)

        loading(true)
        let promise = null
        if (orderData.id) {
          promise = updateItem(orderData)
        } else {
          orderData.centerID = 1
          orderData.studentID = this.$store.getters.newMember.id
          orderData.courseID = this.courseID
          console.log('saveOrderInfo orderData before create order', orderData)
          promise = createOrder(orderData)
        }
        if (promise) {
          promise.then(createResponse => {
            const orderResponse = createResponse.data.record
            this.$store.dispatch('order/saveOrderInfo', orderResponse).then(orderInfo => {
              console.log('store orderInfo', orderInfo)
              this.orderStepper = 4

              // this.isLoading = false

              // resize canvas for signature
              this.$nextTick(() => {
                console.log('this.$refs.orderReview', this.$refs.orderReview)
                this.$refs.orderReview.resizeCanvas()
              })
            })
          }).catch(error => {
            console.log('error', error)

          // this.isLoading = false
          }).finally(() => {
            loading(false)
          })
        }

        // this.orderStepper = 4
      } else {
        this.showMessage('Please enter required information')
        setTimeout(() => {
          this.$refs.orderForm.resetValidation()
          this.$refs.selectCoachList.resetValidation()
        }, 10000)
      }
    },
    saveStudentInfo() {
      const { editedItem } = this.$refs.studentInfo
      const studentFormResult = this.$refs.studentForm.validate()
      console.log('studentFormResult', studentFormResult)
      console.log("this.avatarFile === ''", this.avatarFile === '')
      if (!studentFormResult || this.avatarFile === '') {
        this.showMessage('Please enter all information')
        setTimeout(() => {
          this.$refs.studentForm.resetValidation()
        }, 10000)

        return
      }
      this.$store.dispatch('order/saveNewMember', editedItem).then(async newMember => {
        console.log('saveStudentInfo', newMember)

        loading(true)

        // if student doesn't exist, create new member
        if (!newMember.id) {
          // this.isLoading = true

          const formData = objectToFormData(this.$store.getters.newMember)
          console.log('this.avatarFile', this.avatarFile)
          const avatarFileObj = await base64ToFile(this.avatarFile, 'avatar.png')
          formData.append('avatarFile', avatarFileObj)

          createStudent(formData).then(response => {
            const newRecord = response.data.record
            this.$store.dispatch('order/saveNewMember', newRecord).then(updatedMember => {
              console.log('createStudent store', updatedMember)
            })

            this.$store.dispatch('users/listStudent')
              .then(result => {
                console.log('listStudent result', result)
                this.studentList.length = 0
                this.studentList.push(...result)
              })
              .catch(err => {
                console.log('err', err)
              })

            // createOrderLocal()
          }).finally(() => {
            // this.isLoading = false
            // loading(false)
          })
        }

        // this.isLoading = true
        listCoach({
          page: 0,
          limit: 0,
        }).then(response => {
          console.log('store list response', response)
          const { data } = response

          // commit('SET_COACHLIST', data.items)
          // resolve(data.items)
          this.allCoachList.length = 0
          if (data.items) {
            this.allCoachList.push(...data.items)
          }
        })
          .catch(error => {
            console.log('error', error)

          // reject(error)
          }).finally(() => {
            // this.isLoading = false
            loading(false)
            this.orderStepper = 3
          })
      })
    },
    saveOrderPayment() {
      const { inputAmount } = this.$refs.payment
      const postData = []
      const orderData = { ...this.$store.getters.orderInfo }
      for (const [key, value] of Object.entries(inputAmount)) {
        postData.push({
          salesOrderID: orderData.id,
          paymentMethodID: parseInt(key, 10),
          amount: parseInt(value, 10),
        })
      }

      // this.isLoading = true
      loading(true)
      createPayment({
        salesOrderID: orderData.id,
        payments: postData,
      }).then(response => {
        // this.isLoading = false
        console.log('repsonse', response)
        if (response.code === 20000) {
          this.showMessage('Order completed.')

          // this.studentList.length = 0
          // this.coachList.length = 0

          // const promiseList = [
          //   this.$store.dispatch('users/listStudent'),
          //   this.$store.dispatch('users/listCoach'),
          //   this.$store.dispatch('order/resetNewMember'),
          //   this.$store.dispatch('order/resetOrderInfo'),
          // ]
          // Promise.all(promiseList).then(result => {
          //   const result1 = result[0]
          //   const result2 = result[1]

          //   // this.$router.push('/COACH_Create_Order')
          //   this.$nextTick(() => {
          //     this.$refs.selectStudentList.selectedList = []
          //     this.$refs.selectCoachList.selectedList = []

          //     console.log('listStudent result', result1)
          //     this.studentList.push(...result1)
          //     console.log('listCoach result', result2)
          //     this.coachList.push(...result2)
          //     this.orderStepper = 1
          //   })
          // })
          loading(true)
          setTimeout(() => {
            location.reload()
          }, 500)
        }
      }).finally(() => {
        // this.isLoading = false
        loading(false)
      })
    },
  },
}

</script>
<style scoped>
.orderStepper .v-stepper__content{
  padding: 8px !important;
}

.orderStepper .v-stepper__content .v-card.v-sheet{
  box-shadow: none !important;
}
</style>
